import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import EditCurrentAffiliation from "./editCurrent";
import {
  ReviewPastAffiliations,
  EditPastAffiliation,
  PastAffiliationLayout,
} from "./editPast";

function AffiliationSection() {
  return (
    <Routes>
      <Route path="current" element={<EditCurrentAffiliation />} />
      <Route path="past" element={<PastAffiliationLayout />}>
        <Route index element={<ReviewPastAffiliations />} />
        <Route path=":dateSpecifier" element={<EditPastAffiliation />} />
      </Route>
      <Route path="*" element={<Navigate to="./.." replace />} />
    </Routes>
  );
}
export default AffiliationSection;
